const EPSILON = 3;
const EDGE_SLOP = 6;

function hasNativeVerticalScroll(el) {
    if (!el || typeof el.scrollHeight !== 'number' || typeof el.clientHeight !== 'number') {
        return false;
    }
    if ((el.scrollHeight - el.clientHeight) <= EPSILON) {
        return false;
    }
    if (typeof window === 'undefined' || !window.getComputedStyle) {
        return true;
    }
    const style = window.getComputedStyle(el);
    const overflowY = String(style?.overflowY || '').toLowerCase();
    return overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
}

/** matrix(a,b,c,d,e,f); matrix3d — ty = 13. parametre (m42) */
function parseMatrixTranslateY(transform) {
    if (!transform || transform === 'none') return 0;
    const s = String(transform);
    const mtx = s.match(/matrix\(([-0-9.eE+, ]+)\)/);
    if (mtx) {
        const parts = mtx[1].split(',').map((x) => parseFloat(x.trim()));
        if (parts.length >= 6) return parts[5];
    }
    const t3d = s.match(/matrix3d\(([-0-9.eE+, ]+)\)/);
    if (t3d) {
        const p = t3d[1].split(',').map((x) => parseFloat(x.trim()));
        if (p.length >= 16) return p[13];
    }
    const t3dxy = s.match(/translate3d\(\s*[^,]+\s*,\s*([^,)]+)\s*,/i);
    if (t3dxy) {
        const n = parseFloat(String(t3dxy[1]).replace(/px/gi, ''));
        return Number.isFinite(n) ? n : 0;
    }
    const m2 = s.match(/translateY\(\s*([^)]+)\s*\)/i);
    if (m2) {
        const n = parseFloat(String(m2[1]).replace(/px/gi, ''));
        return Number.isFinite(n) ? n : 0;
    }
    const m2b = s.match(/translate\(\s*[^,)]+,\s*([^)]+)\s*\)/i);
    if (m2b) {
        const n = parseFloat(String(m2b[1]).replace(/px/gi, ''));
        return Number.isFinite(n) ? n : 0;
    }
    return 0;
}

function scrollTopFromTransformOnElement(el, maxTop) {
    if (!el || typeof window === 'undefined' || !window.getComputedStyle) return 0;
    const tf = window.getComputedStyle(el).transform;
    const f = parseMatrixTranslateY(tf);
    return Math.min(maxTop, Math.max(0, -f));
}

/**
 * Layout ile tahmin: her ortamda güvenilir değil (iç padding → sürekli >0 veya 0).
 * Sadece transform 0 iken veya native ile birlikte doğrulama için kullan.
 */
function scrollTopFromContentLayout(container, content, maxTop) {
    const cRect = container.getBoundingClientRect();
    const tRect = content.getBoundingClientRect();
    const raw = Math.round(cRect.top - tRect.top);
    return Math.min(maxTop, Math.max(0, raw));
}

/**
 * Transform önce content’te, yoksa birkaç çocukta (DX tablo sarmalayıcıları).
 */
function bestTransformScrollTop(content, maxTop) {
    if (!content) return 0;
    let v = scrollTopFromTransformOnElement(content, maxTop);
    if (v > EPSILON || v >= maxTop - EPSILON) return v;
    const kids = content.children || [];
    for (let i = 0; i < Math.min(kids.length, 8); i++) {
        const c = scrollTopFromTransformOnElement(kids[i], maxTop);
        if (c > EPSILON || c >= maxTop - EPSILON) return c;
    }
    return v;
}

function getRowsViewEl(target) {
    if (!(target instanceof Element)) return null;
    return target.closest('.dx-datagrid-rowsview');
}

function getGridVerticalWheelState(target) {
    const rowsView = getRowsViewEl(target);
    if (!rowsView) return null;

    const container = rowsView.querySelector('.dx-scrollable-container');
    const content = container?.querySelector?.('.dx-scrollable-content') || null;

    if (!container) return null;

    const ch = container.clientHeight;
    const sh = content
        ? Math.max(content.scrollHeight || 0, content.offsetHeight || 0)
        : container.scrollHeight;
    const maxTop = Math.max(0, sh - ch);
    if (maxTop <= EPSILON) return null;

    const native = Math.min(maxTop, Math.max(0, Number(container.scrollTop || 0)));
    const fromTf = content ? bestTransformScrollTop(content, maxTop) : 0;
    const fromRect = content ? scrollTopFromContentLayout(container, content, maxTop) : 0;

    let scrollTop;

    if (hasNativeVerticalScroll(container)) {
        scrollTop = native;
        if (native <= EPSILON && fromTf > EPSILON) {
            scrollTop = fromTf;
        } else if (native <= EPSILON && fromTf <= EPSILON && fromRect > EPSILON) {
            scrollTop = fromRect;
        }
    } else {
        if (fromTf > EPSILON || fromTf >= maxTop - EDGE_SLOP) {
            scrollTop = fromTf;
        } else if (fromRect > EPSILON) {
            scrollTop = fromRect;
        } else {
            scrollTop = Math.min(maxTop, Math.max(fromTf, fromRect));
        }
    }

    scrollTop = Math.min(maxTop, Math.max(0, scrollTop));

    return {
        scrollTop,
        maxTop,
        chainFromEl: container,
    };
}

function normalizePixelDeltaY(event) {
    let dy = Number(event.deltaY || 0);
    const mode = event.deltaMode;
    if (mode === 1) {
        dy *= 16;
    } else if (mode === 2) {
        dy *= (typeof window !== 'undefined' ? window.innerHeight : 600);
    }
    if (event.shiftKey) {
        const ax = Math.abs(Number(event.deltaX || 0));
        const ay = Math.abs(dy);
        if (ax > ay) dy = Number(event.deltaX || 0);
    }
    return dy;
}

function findOuterScrollElement(fromEl, rootEl) {
    let current = fromEl?.parentElement || null;

    while (current) {
        if (hasNativeVerticalScroll(current)) return current;
        if (rootEl && current === rootEl) break;
        current = current.parentElement;
    }

    if (rootEl && hasNativeVerticalScroll(rootEl)) return rootEl;

    return document.scrollingElement || document.documentElement || document.body || null;
}

function applyScrollToOuter(outerEl, deltaY) {
    if (
        outerEl === document.scrollingElement ||
        outerEl === document.documentElement ||
        outerEl === document.body
    ) {
        window.scrollBy(0, deltaY);
    } else {
        outerEl.scrollTop += deltaY;
    }
}

export function enableGridWheelOuterScroll(rootEl) {
    if (!rootEl || typeof window === 'undefined') {
        return () => {};
    }

    const onWheelCapture = (event) => {
        const state = getGridVerticalWheelState(event.target);
        if (!state || !rootEl.contains(state.chainFromEl)) return;

        const deltaY = normalizePixelDeltaY(event);
        if (!deltaY) return;

        const { scrollTop, maxTop, chainFromEl } = state;
        const atTop = scrollTop <= EDGE_SLOP;
        const atBottom = scrollTop >= (maxTop - EDGE_SLOP);
        const wantsUp = deltaY < 0;
        const wantsDown = deltaY > 0;
        const shouldPassToOuter = (wantsUp && atTop) || (wantsDown && atBottom);

        if (!shouldPassToOuter) return;

        const outerEl = findOuterScrollElement(chainFromEl, rootEl);
        if (!outerEl || outerEl === chainFromEl) return;

        applyScrollToOuter(outerEl, deltaY);

        event.preventDefault();
        event.stopPropagation();
    };

    rootEl.addEventListener('wheel', onWheelCapture, { capture: true, passive: false });

    return () => {
        rootEl.removeEventListener('wheel', onWheelCapture, true);
    };
}
